import { ArrowRight, Close } from '@liveauctioneers/hammer-ui-core/icons';
import { BANNER_GRADIENT_STYLE } from '../helpers/constants';
import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { IconButton } from '@liveauctioneers/hammer-ui-core/iconButton';
import { InlineButton } from '@liveauctioneers/hammer-ui-core/inlineButton';
import { Link } from '@liveauctioneers/hammer-ui-core/link';
import { useHowToWinBannerCTA } from '../hooks/useHowToWinBannerCTA';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';

type HowToWinBannerSlimProps = {
    onDismiss: () => void;
    showCloseButton: boolean;
};

export const HowToWinBannerSlim = ({ onDismiss, showCloseButton }: HowToWinBannerSlimProps) => {
    const { formatMessage } = useIntl();
    const { href, onCTAClick } = useHowToWinBannerCTA();

    return (
        <div
            className={cn('relative h-[38px] w-full px-md py-sm')}
            data-testid="howToWinBannerSlim"
            style={BANNER_GRADIENT_STYLE}
        >
            <div className="flex h-full items-center justify-between gap-sm">
                <div className="align-center flex items-center">
                    <BodyPrimary className="mr-xs font-semibold">
                        {formatMessage({ id: 'howToWinBanner.headline' })}
                    </BodyPrimary>
                    <Link
                        data-testid="howToWinBannerSlimLink"
                        href={href}
                        onClick={onCTAClick}
                        size="sm"
                    >
                        <InlineButton
                            className="flex text-text-primary"
                            data-testid="howToWinBannerSlimCTAButton"
                            icon={ArrowRight}
                            iconPlacement="right"
                            size="sm"
                        >
                            {formatMessage({ id: 'howToWinBanner.cta' })}
                        </InlineButton>
                    </Link>
                </div>
                {showCloseButton && (
                    <IconButton
                        data-testid="howToWinBannerSlimCloseButton"
                        icon={Close}
                        onClick={onDismiss}
                        size="sm"
                    />
                )}
            </div>
        </div>
    );
};
